import styled from 'styled-components';

export const ButtonMoveStyled = styled.button<{ bg: string; hoverBg: string }>`
    border: none;
    font: inherit;
    text-align: inherit;
    outline: none;
    background: ${({ bg }) => bg};
    border-radius: 12px;
    color: var(--color-label-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    &.s {
        background: var(--color-button-secondary-default);
        width: 40px;
        height: 40px;
        max-width: 40px;
        max-height: 40px;
        min-width: 40px;
        min-height: 40px;
    }

    &.xs {
        width: 32px;
        height: 32px;
        max-width: 32px;
        max-height: 32px;
        min-width: 32px;
        min-height: 32px;
    }

    &.xxs {
        border-radius: 8px;
        width: 20px;
        height: 20px;
        max-width: 20px;
        max-height: 20px;
        min-width: 20px;
        min-height: 20px;
    }

    &:hover, &.active {
        background: ${({ hoverBg }) => hoverBg};
    }

    &:focus {
        outline: 1px solid var(--color-button-secondary-highlight);
    }

    &:disabled {
        background: var(--color-button-secondary-inactive);
    }
`;